import { Component } from '@angular/core';
import { CxIconComponent } from '../../shared/icon/cx-icon.component';

@Component({
  selector: 'app-landing-page-get-started',
  standalone: true,
  imports: [CxIconComponent],
  templateUrl: './landing-page-get-started.component.html',
  styleUrl: './landing-page-get-started.component.scss',
})
export class LandingPageGetStartedComponent {}
